import {
  FETCH_ONBOARDING_VIDEOS_FAILURE,
  FETCH_ONBOARDING_VIDEOS_REQUEST,
  FETCH_ONBOARDING_VIDEOS_SUCCESS,
  OnboardingVideosActionTypes,
  OnboardingVideosState,
  UPDATE_ONBOARDING_VIDEO_STEP_PROGRESS,
} from './onboardingVideosTypes';

const initialState: OnboardingVideosState = {
  videos: [],
  modulesCompletionData: {},
  loading: false,
  error: null,
};

const onboardingVideosReducer = (state = initialState, action: OnboardingVideosActionTypes): OnboardingVideosState => {
  switch (action.type) {
    case FETCH_ONBOARDING_VIDEOS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ONBOARDING_VIDEOS_SUCCESS:
      return {
        ...state,
        loading: false,
        videos: action.payload?.modules,
        modulesCompletionData: action.payload?.percentageCompleted,
        error: null,
      };
    case FETCH_ONBOARDING_VIDEOS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ONBOARDING_VIDEO_STEP_PROGRESS:
      return {
        ...state,
        videos: state.videos.map((module) => ({
          ...module,
          steps: module.steps.map((step) =>
            step.id === action.payload.stepId ? { ...step, completed: action.payload.isCompleted } : step
          ),
        })),
      };

    default:
      return state;
  }
};

export default onboardingVideosReducer;
